export default function replaceBlobVideoToCdn(data) {
  return data.replace(
    /https:\/\/jllivemarketplacepub.blob.core.windows.net/g,
    'https://cdnmarket.joblogic.com',
  );
}
